import { useClaService } from "../../../../adapters/cla/state/hooks/useClaService.ts";
import React from "react";
import { useParams } from "react-router";
import { LoadingDots } from "../../../../ui-library/LoadingDots/LoadingDots.tsx";
import type { ImageWidget as ImageWidgetType } from "../../../../feature-components/WidgetLoader/WidgetContext.tsx";

export const ImageWidget: ImageWidgetType = ({ id, values }) => {
  const service = useClaService();
  const [imgContent, setImgContent] = React.useState<string | null>(null);
  const { id: chatId } = useParams();
  React.useEffect(() => {
    service.fetchImageContent(chatId!, id).then((base64) => {
      setImgContent(`data:image/jpeg;base64,${base64}`);
    });
  }, [chatId, id, service]);

  if (!imgContent) {
    return (
      <div>
        Loading image
        <LoadingDots />
      </div>
    );
  }
  return <img src={imgContent} alt={values?.["alt-text"]} />;
};
